define(function(require) {

	const tpl = require('./t_lov_results_view.hbs');
	const results_list_view = require('./v_cpv_results_list_view')
	return Marionette.LayoutView.extend({
		className: 'modal-search-results',
		//tagName:'div',
		//childViewContainer: '.results-list',
		//childView: search_results,
		template: tpl,
		ui:{
			resultsListDiv:'.results-list-region',
			addSiteButton: '.add-site-button',
			clearAll:'.clear-all',
			cancelButton:'.cancel-button'
		},
		regions:{
			resultsListRegion:'@ui.resultsListDiv'
		},
		events: {
			'click @ui.cancelButton': 'cancelClicked',
			'click @ui.addSiteButton': 'addSiteClicked',
			'click @ui.clearAll':'clearAllClicked'
		},
		childEvents: {
			'radioButton:clicked': 'siteSelected'
		},
		views:{},
		initialize: function(options) {
			this.config = options.config;
			this.inMapView = options.inMapView ? true : false;
			this.listCollection = options.collection;
		},

		onShow:function(){
			this.views.resultsListView = new results_list_view({
				config:this.config,
				collection:this.listCollection
			});
			this.resultsListRegion.show(this.views.resultsListView);
		},
		onRender: function() {
		},
		clearAllClicked:function(e){
			if(e.preventDefault){
				e.preventDefault();
			}
			this.ui.addSiteButton.attr('disabled',true);
			this.triggerMethod('clearAllClicked');
		},
		siteSelected:function(childView, selectedSiteID, description, model){
			this.triggerMethod('siteSelected',selectedSiteID, description, model);
			this.ui.addSiteButton.removeAttr('disabled');

		},
		templateHelpers: function() {
			return {
				noResults:this.listCollection.length == 0,
				maxResults:this.listCollection.length == 100,
				inMapView:this.inMapView
			}
		}
	});
});
